// Package Imports
import { toJS } from "mobx";

// Project Imports
import axios from "utils/axios";
import * as APITypes from "constants/API";
import isObjectEmpty from "utils/isObjectEmpty";
import fetchNeedMasterData from 'utils/fetchNeedMasterData'
import NeedTypeEnum from "constants/NeedTypeEnum";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import fetchNeedMaster from "utils/fetchNeedMasterData";
import AuthStore from "modules/login/store/AuthStore";
import { EMPLOYER_EMPLOYEE_SCHEME_B, INDIVIDUAL, MWP_ACT } from "constants/ CustomerType";
import incomeTypeEnum from "constants/incomeTypeEnum";
import { prefillProductsList } from "./utils";
import StorageKeys from "constants/StorageKeys";



const initialDefaults = async (formController, journeyData, journeyId) => {

  if (journeyId !== undefined) {
    formController.$("journey_id").value = journeyId.toString()
  }

  let NeedMasterData = await fetchNeedMasterData();

  let saveForRetirement = NeedMasterData.find((item) => item.unique_name === NeedTypeEnum.SAVE_FOR_RETIREMENT)
  let selectedFamilyMember = journeyData.family_details_list.filter((item) => item.id === OptimizationStore.selectedFamilyMemberId)[0]

  let selfData = (AuthStore.journeyTypeName === INDIVIDUAL || AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT) ? journeyData.family_details_list[0] : journeyData.family_details_list[1]

  let targetAmountOfSelectedFamilyMember = selectedFamilyMember?.family_product_details_list?.find((item) => item.need_unique_name === NeedTypeEnum.SAVE_FOR_RETIREMENT)
  let targetAmountOfSelf = selfData?.family_product_details_list?.find((item) => item.need_unique_name === NeedTypeEnum.SAVE_FOR_RETIREMENT)

  let selectedTargetAmount = targetAmountOfSelectedFamilyMember && targetAmountOfSelectedFamilyMember?.target_amount || targetAmountOfSelf && targetAmountOfSelf?.target_amount

  let allProductListData = await prefillProductsList()
  let isUlipUser = localStorage.getItem(StorageKeys.ULIP_TRAINING) === "1"
    let filterdata = []
    
    if (!isUlipUser) {
        filterdata = allProductListData[NeedTypeEnum.SAVE_FOR_RETIREMENT] .filter((item) => item.risk != "high");
    } else {
        filterdata = allProductListData[NeedTypeEnum.SAVE_FOR_RETIREMENT] 
    }

  formController.$("products_list").set("extra", {
    ...formController.$("products_list").extra,
    preDefinedOptList: filterdata ? filterdata : []
  })


  formController.$("target_amount_dropdown").set("extra", {
    ...formController.$("target_amount_dropdown").extra,
    optionList: saveForRetirement.target_amount
  })

  if (selectedTargetAmount?.target_amount) {
    let targetAmount = saveForRetirement.target_amount.filter((item) => item.id === selectedTargetAmount.target_amount)[0]
    formController.$("target_amount_dropdown").set("value", targetAmount)
  } else {
    formController.$("target_amount_dropdown").value = saveForRetirement.target_amount[0]
  }

  let productList = formController.$("products_list").extra.preDefinedOptList
  let filterProductList = productList.filter(item => item.payout_type.toLowerCase()  === incomeTypeEnum.INCOME.toLowerCase())

  formController.$("products_list").set("extra", {
    ...formController.$("products_list").extra,
    optionList: filterProductList ? filterProductList : []
  })
  // formController.$("products_list").set("value", filterProductList[0])



  if (isObjectEmpty(journeyData)) {
    return
  }

}

export default initialDefaults